/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Thumbnail_Folders_SectionInputs */

const en_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Folders`)
};

const fr_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossiers`)
};

const de_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordner`)
};

const it_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartelle`)
};

const ru_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Папки`)
};

const es_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpetas`)
};

const zh_cn2_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件夹`)
};

const ja_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォルダ`)
};

const hi_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ोल्डर`)
};

const pt_pt2_explorer_thumbnail_folders_section = /** @type {(inputs: Explorer_Thumbnail_Folders_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastas`)
};

/**
* | output |
* | --- |
* | "Folders" |
*
* @param {Explorer_Thumbnail_Folders_SectionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_thumbnail_folders_section = /** @type {((inputs?: Explorer_Thumbnail_Folders_SectionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Thumbnail_Folders_SectionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_thumbnail_folders_section(inputs)
	if (locale === "de") return de_explorer_thumbnail_folders_section(inputs)
	if (locale === "it") return it_explorer_thumbnail_folders_section(inputs)
	if (locale === "ru") return ru_explorer_thumbnail_folders_section(inputs)
	if (locale === "es") return es_explorer_thumbnail_folders_section(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_thumbnail_folders_section(inputs)
	if (locale === "ja") return ja_explorer_thumbnail_folders_section(inputs)
	if (locale === "hi") return hi_explorer_thumbnail_folders_section(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_thumbnail_folders_section(inputs)
	return en_explorer_thumbnail_folders_section(inputs)
});